<template>
  <Teleport to="body">
    <vue-final-modal
      v-model="showModal"
      classes="modal-container"
      content-class="modal-content reload-time-modal"
      overlay-class="vfm__overlay"
      :click-to-close="true"
      :lock-scroll="true"
      :hide-overlay="false"
      :esc-to-close="true"
      @click:overlay="closeModal"
      @click="handleOutsideClick"
    >
      <div class="p-3" @click.stop>
        <div class="row">
          <div class="col-md-12">
            <b>自動更新時間を選択</b>
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-md-12 text-center">
            <select class="form-control"
                    v-model="reloadTime"
                    required>
              <option v-for="item in timeList"
                      :value="item.value"
                      :key="item.value">
                {{item.text}}
              </option>
            </select>
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-md-12 text-right">
            <a href="#" @click.prevent="close">キャンセル</a>
            <span class="mx-2"></span>
            <button class="action-button btn btn-rounded btn-success"
                    @click="save">
              自動更新時間を変更
            </button>
          </div>
        </div>
      </div>
    </vue-final-modal>
  </Teleport>
</template>

<script setup>
import { ref, watch, computed } from 'vue'
import { VueFinalModal } from 'vue-final-modal'

const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false
  },
  reload: {
    type: Number,
    default: null
  }
})

const emit = defineEmits(['update:modelValue', 'timeSet', 'cancel'])

// Computed property for v-model binding
const showModal = computed({
  get: () => props.modelValue,
  set: (value) => {
    emit('update:modelValue', value)
  }
})

const reloadTime = ref(null)
const timeList = [
  { value: null, text: '更新しない' },
  { value: 60000, text: '1分' },
  { value: 300000, text: '5分' },
  { value: 600000, text: '10分' }
]

watch(() => props.modelValue, (newVal) => {
  if (newVal) {
    // Khi modal mở, set giá trị từ props
    reloadTime.value = props.reload
  }
})

const close = () => {
  emit('cancel')
  emit('update:modelValue', false)
}

const closeModal = () => {
  emit('update:modelValue', false)
}

const handleOutsideClick = (event) => {
  if (event.target.classList.contains('vfm__overlay')) {
    emit('update:modelValue', false)
  }
}

const save = () => {
  // Đảm bảo giá trị là null hoặc number
  const valueToEmit = reloadTime.value === null ? null : Number(reloadTime.value)

  emit('timeSet', valueToEmit)
  emit('update:modelValue', false)
}
</script>

<style>
.modal-container {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 2000;
}

.modal-content {
  position: relative;
  display: flex;
  flex-direction: column;
  margin: 0 1rem;
  padding: 1rem;
  border: 1px solid #e2e8f0;
  border-radius: 0.25rem;
  background: #fff;
  width: 400px;
  z-index: 2001;
}

.content {
  width: 100%;
}

select.form-control {
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  line-height: 1.5;
  border-radius: 0.25rem;
  border: 1px solid #ced4da;
}

.btn-link {
  text-decoration: none;
  color: #6c757d;
}

.btn-link:hover {
  color: #4b5156;
  text-decoration: underline;
}

.reload-time-modal {
  width: 400px !important;
}
</style>
